import { fetchApi } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';
import { useQuery } from '@tanstack/react-query';
import type { Me } from '@ultimate-checklist/shared';

export function useMe() {
  return useQuery({
    queryKey: queryKeys.me,
    queryFn: ({ signal }) => fetchApi<Me>('/api/me', { signal }),
  });
}
